import { Theme } from '@mui/material/styles';
import { SystemProps } from '@mui/system';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import unknownUserIcon from 'assets/images/avatar_placeholder.png';
import React, { FC, useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import { useStyles } from './TeamIcon.styles';
import { TeamVsTeamEntity } from 'shared/interfaces';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import { getUserAvatarUrl } from 'shared/utils/user-avatar';
import { getTeamCaptain } from 'shared/utils/get-team-captain';

type UserAvatarProps = {
  team: TournamentTeamEntity | TeamVsTeamEntity;
  tooltip?: string;
  size?: number;
  borderColor?: string;
} & SystemProps<Theme>;

export const TeamIcon: FC<UserAvatarProps> = ({
  team,
  size = 48,
  borderColor,
  tooltip = '',
  ...rest
}) => {
  const convertedSize = useMemo(() => size / 8, [size]);
  const { classes } = useStyles({ size: convertedSize, borderColor });

  const icon = useMemo(() => {
    let user = null;

    if (!team) return '';

    if ('players' in team) {
      user = getTeamCaptain(team)?.user;
    } else if ('captain' in team) {
      user = team.captain;
    }

    return user ? getUserAvatarUrl(user, size) : '';
  }, [team, size]);

  return (
    <Tooltip enterTouchDelay={0} title={tooltip}>
      <Box className={classes.root} {...rest}>
        {!Boolean(icon) ? (
          <img src={unknownUserIcon} />
        ) : (
          <Box className={classes.avatar}>
            <LazyLoadImage
              src={icon}
              placeholderSrc={unknownUserIcon}
              width="100%"
              height="100%"
              alt="team icon"
            />
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};
